<template>
    <span class="flag-icon" :class="[`flag-icon-${countryCode}`]"></span>
</template>

<script>
export default {
    name: 'countryFlag',
    props: {
        countryCode: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
    @import "flags/flag-icon";
</style>
